module.exports = __webpack_public_path__ + "img/sparkles-bg.ecb2997.svg";